import { css } from '@emotion/react';
import { Icon, NotiIcon } from '@anytag/shared-atoms';
import { THEME } from '@anytag/shared-constants';
import { IconNames } from '@anytag/shared-assets';
import { useChatRoomContext } from '../chat-room-context';

export const ToastMessage = () => {
  const { toastMessage, clearToastMessage } = useChatRoomContext();

  const { backgroundColor, prefixIcon } = ((): { backgroundColor: string; prefixIcon: IconNames | null } => {
    switch (toastMessage?.type) {
      case 'error':
        return {
          prefixIcon: 'info',
          backgroundColor: THEME.attention.colors.red
        };
      case 'success':
        return {
          prefixIcon: null,
          backgroundColor: THEME.attention.colors.green
        };
      case 'info':
      default:
        return { backgroundColor: THEME.attention.colors.blue, prefixIcon: 'info' };
    }
  })();

  return toastMessage ? (
    <div css={[styles.wrapper, { backgroundColor }]}>
      {prefixIcon ? (
        <NotiIcon size={14} icon={prefixIcon} variant="white" css={{ margin: 0, transform: 'translateY(2px)' }} />
      ) : null}
      <div>{toastMessage.message}</div>
      <Icon
        size={10}
        icon="close"
        onClick={clearToastMessage}
        variant="white"
        css={{ cursor: 'pointer', marginLeft: 'auto' }}
      />
    </div>
  ) : null;
};

const styles = {
  wrapper: css({
    gap: '4px',
    top: '8px',
    left: '50%',
    padding: '8px',
    display: 'flex',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '100%',
    fontStyle: 'normal',
    width: 'max-content',
    position: 'absolute',
    borderRadius: '8.4px',
    alignItems: 'baseline',
    letterSpacing: 'normal',
    boxSizing: 'border-box',
    maxWidth: 'calc(100% - 32px)',
    transform: 'translateX(-50%)',
    color: THEME.text.colors.white
  })
};
